import * as React from 'react';
import Container from '@mui/material/Container';
import { DataGrid } from '@mui/x-data-grid';
import {useEffect} from "react";
import Authorize from "../../../components/Authorize";
import { styled } from '@mui/material';

interface RequestItemProps {
    id: number;
    ipAddress: string;
    value: string;
    date: Date;
}

const StyledBox = styled(Container)(({ theme }) => ({
    height: 600
}));

const Overview = (): React.ReactElement => {
    const [list, setList] = React.useState<RequestItemProps[]>([]);

    const fetchList = async () => {
        const result = await fetch("/api/v1/Requests", {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem("echo-si-jwt")}`
            }
        });

        if(result.status == 200) return (await result.json()).result;
        else return [];
    }

    useEffect(() => {
        fetchList().then(setList);
    }, []);

    return (
        <>
            <Authorize/>
            <StyledBox maxWidth="lg">
                <DataGrid
                    columnThreshold={3}
                    columns={[
                        { field: 'ipAddress', width: 250, headerName: 'IP Address' },
                        { field: 'value', width: 450, headerName: 'Log Message' },
                        { field: 'date', width: 250, headerName: 'Log Date', valueGetter: (params: any) => new Date(params.value).toLocaleString() }
                    ]}
                    rows={list}
                />
            </StyledBox>
        </>
    );
};

export default Overview;